import { InventoryData } from "./InventoryData";
import { ComplementData } from "./ComplementData";
import { PromotionData } from "./PromotionData";
import { ExtraData } from "./ExtraData";
import { BundleInventoryData } from "./BundleInventoryData";

export class ARIData {
  inventories?: InventoryData[];
  promos?: PromotionData[];
  extras?: ExtraData[];
  complements?: ComplementData[];
  bundleInventories?: BundleInventoryData[];

  constructor(
    inventories: InventoryData[],
    promos: PromotionData[],
    extras: ExtraData[],
    complements: ComplementData[],
    bundleInventories: BundleInventoryData[]
  ) {
    this.inventories = inventories;
    this.promos = promos;
    this.extras = extras;
    this.complements = complements;
    this.bundleInventories = bundleInventories;
  }

  static of(
    inventoryData: InventoryData[],
    promotionData: PromotionData[],
    extraData: ExtraData[],
    complementData: ComplementData[],
    bundleInventories: BundleInventoryData[]
  ): ARIData {
    return new ARIData(inventoryData, promotionData, extraData, complementData, bundleInventories);
  }
}
